import { useEffect, useState, useRef } from 'react';
import { useSubNav } from '../contexts/SubNavContext';
import './Contact.css';

export default function Contact() {
    const { setSubNav } = useSubNav();
    const [activeOffice, setActiveOffice] = useState('1');
    const mapInstanceRef = useRef(null);
    const [mapLoaded, setMapLoaded] = useState(false);

    const handleOfficeClick = (officeNum) => {
        setActiveOffice(officeNum);
    };

    useEffect(() => {
        setSubNav([
            { 
                href: '#', 
                label: '본사', 
                active: activeOffice === '1',
                onClick: (e) => {
                    e.preventDefault();
                    handleOfficeClick('1');
                }
            },
            { 
                href: '#', 
                label: '남부사무소', 
                active: activeOffice === '2',
                onClick: (e) => {
                    e.preventDefault();
                    handleOfficeClick('2');
                }
            }
        ]);

        return () => setSubNav(null);
    }, [setSubNav, activeOffice]);

    useEffect(() => {
        const KAKAO_KEY = 'fe3cbf257eeeb1970f6cb6cd7a6baf46';

        const init = () => {
            if (!window.kakao || !window.kakao.maps) return;
            window.kakao.maps.load(() => {
            initMap();
            });
        };

        if (window.kakao && window.kakao.maps) {
            init();
            return;
        }

        const script = document.createElement('script');
        script.src = `https://dapi.kakao.com/v2/maps/sdk.js?appkey=${KAKAO_KEY}&autoload=false`;
        script.async = true;
        script.onload = init;
        document.head.appendChild(script);
    }, []);


    useEffect(() => {
        if (mapLoaded && mapInstanceRef.current) {
            setMapCenter(activeOffice);
        }
    }, [activeOffice, mapLoaded]);

    const initMap = () => {
        const container = document.getElementById('map');
        if (!container) {
            console.error('지도 컨테이너를 찾을 수 없습니다');
            return;
        }

        if (!window.kakao || !window.kakao.maps) {
            console.error('카카오맵 API가 로드되지 않았습니다');
            return;
        }

        try {
            const options = {
                center: new window.kakao.maps.LatLng(37.507373, 127.034048),
                level: 4
            };

            mapInstanceRef.current = new window.kakao.maps.Map(container, options);

            // 마커 추가
            const positions = [
                {
                    title: '서울사무소',
                    latlng: new window.kakao.maps.LatLng(37.504422, 127.0328541),
                    imageSrc: '/resources/img/PIN_seoul2.png?=v2'
                },
                {
                    title: '남부사무소',
                    latlng: new window.kakao.maps.LatLng(35.5410724, 129.3483804),
                    imageSrc: '/resources/img/PIN_branch.png?=v1'
                }
            ];

            positions.forEach((pos) => {
                const imageSize = new window.kakao.maps.Size(210, 80);
                const markerImage = new window.kakao.maps.MarkerImage(pos.imageSrc, imageSize);

                new window.kakao.maps.Marker({
                    map: mapInstanceRef.current,
                    position: pos.latlng,
                    title: pos.title,
                    image: markerImage
                });
            });

            // 줌 비활성화
            mapInstanceRef.current.setZoomable(false);

            // 컨트롤 추가
            const mapTypeControl = new window.kakao.maps.MapTypeControl();
            mapInstanceRef.current.addControl(mapTypeControl, window.kakao.maps.ControlPosition.TOPLEFT);

            const zoomControl = new window.kakao.maps.ZoomControl();
            mapInstanceRef.current.addControl(zoomControl, window.kakao.maps.ControlPosition.LEFT);

            setMapLoaded(true);
            console.log('지도 초기화 완료');
        } catch (error) {
            console.error('지도 초기화 오류:', error);
        }
    };

    const setMapCenter = (comp) => {
        if (!mapInstanceRef.current) return;

        const coords = comp === '1' 
            ? { lat: 37.504422, lng: 127.0328541 }
            : { lat: 35.5410724, lng: 129.3483804 };

        const moveLatLon = new window.kakao.maps.LatLng(coords.lat, coords.lng);
        mapInstanceRef.current.setCenter(moveLatLon);

        // 원하는 줌 레벨로 고정
        mapInstanceRef.current.setLevel(4);
    };

    return (
        <>
            <div className="container map">
                <div id="map" className="cont_map" style={{ width: '100%', height: '404px' }}></div>

                <div className={`cont wrap_cont flip_cont ${activeOffice === '1' ? 'on' : ''}`}>
                    <div className="cont_p width_f" id="mark1">
                        <h3>본사</h3>
                        <table>
                            <colgroup>
                                <col style={{ width: '13%' }} />
                                <col style={{ width: '37%' }} />
                                <col style={{ width: '13%' }} />
                                <col style={{ width: '37%' }} />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>주소</th>
                                    <td colSpan="3">서울특별시 강남구 봉은사로20길 41 와이앤씨빌딩</td>
                                </tr>
                                <tr>
                                    <th>대표번호</th>
                                    <td>02-544-7896</td>
                                    <th>팩스번호</th>
                                    <td>02-540-7897</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className={`cont wrap_cont flip_cont ${activeOffice === '2' ? 'on' : ''}`}>
                    <div className="cont_p width_f" id="mark2">
                        <h3>남부사무소</h3>
                        <table>
                            <colgroup>
                                <col style={{ width: '13%' }} />
                                <col style={{ width: '37%' }} />
                                <col style={{ width: '13%' }} />
                                <col style={{ width: '37%' }} />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>주소</th>
                                    <td colSpan="3">울산광역시 동구 방어진순환도로 775 KT동울산지사 3층</td>
                                </tr>
                                <tr>
                                    <th>대표번호</th>
                                    <td>02-544-7896</td>
                                    <th>팩스번호</th>
                                    <td>02-540-7897</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}
